import { diagnosticLog } from './diagnosticLogger';

export type BillingCheckoutSource = 'SubscriptionProvider' | 'SubscribePage';

/** Fleet-visible billing checkout failure (Tauri JSONL → js:billing; console always). */
export function logBillingCheckoutFailure(
  source: BillingCheckoutSource,
  opts: {
    status: number;
    error?: string | null;
    tier?: string | null;
    had_trial?: boolean;
    stripe_customer_id?: boolean;
    already_subscribed?: boolean;
    stripe_code?: string | null;
    request_id?: string | null;
  },
): void {
  const message = `create-checkout-session failed (${source})`;
  diagnosticLog('error', 'js:billing', message, {
    status: opts.status,
    error: opts.error ?? null,
    tier: opts.tier ?? null,
    had_trial: opts.had_trial ?? null,
    stripe_customer_id_present: !!opts.stripe_customer_id,
    already_subscribed: opts.already_subscribed ?? false,
    stripe_code: opts.stripe_code ?? null,
    request_id: opts.request_id ?? null,
    source,
  });
  console.error(`[js:billing] ${message}`, opts);
}
